import { render, staticRenderFns } from "./GroupsCreateDoc.vue?vue&type=template&id=6c8ba638"
import script from "./GroupsCreateDoc.vue?vue&type=script&lang=js"
export * from "./GroupsCreateDoc.vue?vue&type=script&lang=js"
import style0 from "./GroupsCreateDoc.vue?vue&type=style&index=0&id=6c8ba638&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports